export class PaginationViewModel {

    items_per_page: number;                 // Items to display per page
    total_items: number;                    // Total items 
    current_page: number;                   // Current page to display
    last_page: number;                      // Last page to display
    has_next_page: boolean;                 // Flag that determine if has next page to display
    has_previous_page: boolean;             // Flag that determine if has previous page to display

    constructor() {
        this.items_per_page = 10;
        this.total_items = 1;
        this.current_page = 1;
        this.last_page = 1;
        this.has_next_page = false;
        this.has_previous_page = false;
    }

}